// Import the React library for building user interfaces
import React from 'react';

// Import the ReactDOM library for rendering React components in the DOM
import ReactDOM from 'react-dom/client';

// Import the Provider component from react-redux for connecting React components to a Redux store
import { Provider } from 'react-redux';

// Import the function to configure the Redux store
import configureReduxStore from './store';

// Import the root App component
import App from './App';

// Import the function to report web vitals for performance measurement
import reportWebVitals from './reportWebVitals';

// Import the main router object for the application
import AppNavigation from './navigator/AppNavigation';

// Import global SCSS styles for the application
import './assets/css/scss/app.scss';

// Import the MSAL instance initializer
import { initializeMsalInstance } from './utils/msalInstance';

// Import the default theme for Kendo UI components
// import '@progress/kendo-theme-default/dist/all.css';

// Import styles for React Toastify notifications
import 'react-toastify/dist/ReactToastify.css';




import { IntlProvider, load } from '@progress/kendo-react-intl';


import likelySubtags from "cldr-data/supplemental/likelySubtags.json";
import currencyData from "cldr-data/supplemental/currencyData.json";
import weekData from "cldr-data/supplemental/weekData.json";
import timeData from "cldr-data/supplemental/timeData.json";
import numberingSystems from "cldr-data/supplemental/numberingSystems.json";

// For GBP support (UK)
import numbersGb from "cldr-data/main/en-GB/numbers.json";
import currenciesGb from "cldr-data/main/en-GB/currencies.json";

load(likelySubtags,
  currencyData,
  weekData,
  timeData,
  numberingSystems, 
  numbersGb, 
  currenciesGb);

// Create a root container for React components using ReactDOM.createRoot
const root = ReactDOM.createRoot(
  document.getElementById(`${process.env.REACT_APP_HTML_ROOT}`) as HTMLElement
);

// Configure and create the Redux store
const store = configureReduxStore();

// Initialize MSAL before rendering to ensure the shared instance is ready
initializeMsalInstance().then(() => {
  // Render the React components inside the root container
  root.render(
    // <React.StrictMode> could be used here for additional checks and warnings during development
    <Provider store={store}> {/* Provide the Redux store to React components */}
    <IntlProvider locale="en-GB">
      <App> {/* The root App component */}
        <AppNavigation /> {/* The main router object for the application */}
      </App>
      </IntlProvider>
    </Provider>
    // </React.StrictMode>
  );
});

// Record and log web vitals for performance analysis
// Learn more about measuring web vitals: https://bit.ly/CRA-vitals
reportWebVitals();